module.exports = __webpack_public_path__ + "img/logo.18dfecf2.png";